import axios from "axios";

export const TOKEN_STORAGE_KEY = "rv_token";
export const USER_STORAGE_KEY = "rv_user";

const resolveBaseUrl = () => {
  const explicitBase = process.env.REACT_APP_API_BASE_URL;
  if (explicitBase) {
    return explicitBase.replace(/\/+$/, "");
  }

  const defaultPort = process.env.REACT_APP_API_PORT ?? "7290";

  if (typeof window !== "undefined") {
    const { protocol, hostname, port: browserPort } = window.location;

    if (process.env.NODE_ENV !== "production" && browserPort === "3000") {
      return "/api";
    }

    const portSegment = defaultPort ? `:${defaultPort}` : "";
    return `${protocol}//${hostname}${portSegment}/api`;
  }

  return defaultPort
    ? `http://localhost:${defaultPort}/api`
    : "http://localhost/api";
};

const api = axios.create({
  baseURL: resolveBaseUrl(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token) {
    // Ensure headers object exists
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Skip automatic logout if the request was marked to suppress it
    const skipAutoLogout = error.config?.skipAutoLogout;
    const currentPath = window.location.pathname || "";
    const isPublicApplyPath = currentPath === "/apply" || currentPath.startsWith("/apply/");
    
    if (error.response?.status === 401 && !skipAutoLogout && !isPublicApplyPath) {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      localStorage.removeItem(USER_STORAGE_KEY);

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;